import { useState } from 'react';
import { OperatorAuditPanel } from './OperatorAuditLog.tsx';
import { OperatorDoctorsPanel } from './OperatorDoctors.tsx';
import { OperatorOrganizationsPanel } from './OperatorOrganizations.tsx';
import { OperatorPatientsPanel } from './OperatorPatients.tsx';
import { OperatorHygienePanel, OutstandingPaymentsPanel, RecoverableConversationsPanel } from './OperatorHygiene.tsx';
import { OperatorSupportTicketsPanel } from './OperatorSupportTickets.tsx';
import styles from './OperatorOperations.module.css';

type Tab = 'artsen' | 'organisaties' | 'patienten' | 'audit' | 'hygiene' | 'tickets';

const TABS: [Tab, string][] = [
  ['artsen',       'Artsen'],
  ['organisaties', 'Organisaties'],
  ['patienten',    'Patiënten'],
  ['audit',        'Auditlogboek'],
  ['hygiene',      'Gegevensbeheer'],
  ['tickets',      'Support tickets'],
];

export function OperatorOperations() {
  const [activeTab, setActiveTab] = useState<Tab>('artsen');

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <h1 className="page-heading">Beheer</h1>

        <div className={styles.tabs} role="tablist" aria-label="Beheer secties">
          {TABS.map(([key, label]) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={activeTab === key}
              onClick={() => setActiveTab(key)}
              className={`${styles.tab}${activeTab === key ? ` ${styles.tabActive}` : ''}`}
            >
              {label}
            </button>
          ))}
        </div>

        {activeTab === 'artsen'       && <OperatorDoctorsPanel />}
        {activeTab === 'organisaties' && <OperatorOrganizationsPanel />}
        {activeTab === 'patienten'    && <OperatorPatientsPanel />}
        {activeTab === 'audit'        && <OperatorAuditPanel />}
        {activeTab === 'hygiene'      && (
          <>
            <OperatorHygienePanel />
            <OutstandingPaymentsPanel />
            <RecoverableConversationsPanel />
          </>
        )}
        {activeTab === 'tickets'      && <OperatorSupportTicketsPanel />}
      </div>
    </div>
  );
}
